import React from "react";
import { Modal } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { handleModalAction } from "../../../../utils/helpers/handleModalAction";
import useReminders from "../hooks/useReminders";
import { toast } from "react-toastify";

const SetReminderModal = ({ data, module }) => {
  const { setReminder } = useReminders(module);
  // console.log("data",data);
  

  // Formik Setup
  const formik = useFormik({
    initialValues: {
      leadId: data?._id || "",
      reminderDateTime: new Date(),
      reminderMessage: "",
      leadMetaDetails: {
        leadName: data?.firstName + " " + data?.lastName || "",
        status: data?.currentStatus?.name || "",
        phoneno: data?.mobile || "",
      },
    },
    validationSchema: Yup.object({
      reminderDateTime: Yup.date().required("Reminder date is required"),
      reminderMessage: Yup.string().required("Reminder message is required"),
    }),
    onSubmit: (values) => {
      setReminder.mutate(values, {
        onSuccess: () => {
          formik.resetForm();
          handleModalAction("setReminderModal", "hide");
        },
      });
    },
  });

  // Handle separate date and time changes
  const handleDateChange = (date) => {
    const currentDate = new Date(formik.values.reminderDateTime);
    const updatedDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      currentDate.getHours(),
      currentDate.getMinutes()
    );
    formik.setFieldValue("reminderDateTime", updatedDate);
  };

  const handleTimeChange = (time) => {
    const currentDate = new Date(formik.values.reminderDateTime);
    const updatedDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      time.getHours(),
      time.getMinutes()
    );
    formik.setFieldValue("reminderDateTime", updatedDate);
  };

  return (
    <div
      className="modal fade"
      id="setReminderModal"
      tabIndex="-1"
      aria-labelledby="setReminderModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          {/* Modal Header */}
          <div className="modal-header">
            <h5 className="modal-title" id="setReminderModalLabel">
              Set Reminder for {data?.firstName} {data?.lastName}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          {/* Modal Body */}
          <div className="modal-body">
            <form onSubmit={formik.handleSubmit}>
              {/* Date & Time Pickers */}
              <div className="mb-3">
                <label className="form-label">Select Date & Time</label>
                <div className="d-flex gap-2">
                  {/* Date Picker */}
                  <DatePicker
                    selected={formik.values.reminderDateTime}
                    onChange={handleDateChange}
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                  />

                  {/* Time Picker */}
                  <DatePicker
                    selected={formik.values.reminderDateTime}
                    onChange={handleTimeChange}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    dateFormat="h:mm aa"
                    className="form-control"
                  />
                </div>
                {formik.errors.reminderDateTime && (
                  <div className="text-danger">
                    {formik.errors.reminderDateTime}
                  </div>
                )}
              </div>

              {/* Reminder Message */}
              <div className="mb-3">
                <label className="form-label">Reminder Message</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter reminder details..."
                  {...formik.getFieldProps("reminderMessage")}
                ></textarea>
                {formik.errors.reminderMessage && (
                  <div className="text-danger">
                    {formik.errors.reminderMessage}
                  </div>
                )}
              </div>

              {/* Modal Footer */}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-dark"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={setReminder.isPending}
                >
                  {setReminder.isPending ? "Saving..." : "Set Reminder"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetReminderModal;
